module.exports = __webpack_public_path__ + "img/postal-horn.ae697103.png";